import infographie from "../../images/infograpie.jpg";
const WaterPrice = () => {
  return (
    <div className="container mx-auto mt-10 mb-20 md:px-40 sm:px-40">
      <div className="font-bold">Comment est calculé le prix de l’eau ?</div>
      <p className="mt-2 text-justify">
        Si à l’état naturel l’eau est gratuite, son traitement et sa
        distribution ont un coût. Le prix de l’eau intègre les prestations des
        différents acteurs du service de l’eau (prélèvement, traitement,
        distribution, retraitement) ainsi que les taxes et redevances. Le prix
        de l’eau se décompose en trois parties :
      </p>

      <div className="flex justify-center">
        <img
          className="text-justify w-96"
          src={infographie}
          alt="infographie"
        />
      </div>

      <div className="font-bold">Comment êtes-vous facturé ?</div>
      <p className="mt-2 text-justify">
        En général, deux factures d’eau vous sont adressées dans l’année : la
        première est estimative, la deuxième est calculée d’après la
        consommation réelle, si le relevé du compteur a eu lieu. Si votre
        compteur n’a pu être relevé, votre facture est alors calculée sur une
        estimation de votre consommation d’eau à partir de vos trois factures
        précédentes, et porte la mention « consommation estimée ». Le montant
        est régularisé lors du relevé suivant.
      </p>

      <div className="mt-5 mb-5 rounded-lg bg-primary">
        <div className="p-5">
          <span className="font-bold">Aquavasc</span> a décidé, en 2017, de
          déployer sur son territoire un service de télérelève, Aviz’eau.
          Déployé progressivement entre 2018 et 2020, ce nouveau dispositif
          présente de nombreux avantages :
          <ul className="ml-8 list-disc">
            <li>
               être facturé en fonction de vos{" "}
              <span className="font-bold">consommations réelles</span>
            </li>
            <li>
               être alerté en cas de consommation{" "}
              <span className="font-bold">inhabituelle</span>{" "}
            </li>
            <li>
              suivre votre consommation d’eau en direct sur{" "}
              <span className="font-bold">internet</span> pour une meilleure
              maîtrise
            </li>
            <li>ne plus être dérangé pour le relevé du compteur.</li>
          </ul>
          source : <span className="font-bold">toutsurmoneau.fr</span>
        </div>
      </div>

      <div className="p-3 mt-4 border border-primary">
        <p className="text-xl font-bold text-center ">
          Pour consulter le détail de votre facture, renseignez-vous auprès du
          <a
            href="/a-propos-de-nous#partenaire"
            className="cursor-pointer"
            //target="_blank"
          >
            {" "}
            <span className="underline text-primary">délégataire</span>{" "}
          </a>{" "}
          chargée de la distribution de l’eau potable sur votre commune.
        </p>
      </div>
    </div>
  );
};

export default WaterPrice;
